import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Divider, ToastContext } from '@reveni-io/reveni-ui'

import SaveChangesButtons from '@/common/components/SaveChangesButtons/SaveChangesButtons'
import UnsavedChangesAlert from '@/common/components/UnsavedChangesAlert/UnsavedChangesAlert'
import { userPermissions } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import useReturnReasonsSettings from './hooks/useReturnReasonsSettings/useReturnReasonsSettings'
import RejectedProductsSection from './RejectedProductsSection/RejectedProductsSection'
import ReturnReasonsSettingsConfigurationSkeleton from './ReturnReasonsSettingsConfigurationSkeleton/ReturnReasonsSettingsConfigurationSkeleton'
import SortingSettingsSection from './SortingSettingsSection/SortingSettingsSection'
import * as Styles from './styles'

const ReturnReasonsSettingsConfiguration = () => {
  const { t } = useTranslation()
  const { info } = useContext(AppContext)
  const { setToastInfo } = useContext(ToastContext)
  const { hasPermission } = useUserPermissions()
  const {
    loading,
    saving,
    hasChanges,
    revertChanges,
    showRejectedNotesAndImages,
    setShowRejectedNotesAndImages,
    returnReasonsSorting,
    setReturnReasonsSorting,
    returnSubreasonsSorting,
    setReturnSubreasonsSorting,
    onSave,
  } = useReturnReasonsSettings({ returnPortalId: info.selectedReturnPortal?.id, setToastInfo })

  const canEdit = hasPermission(userPermissions.editReturnReasons)

  if (loading) {
    return <ReturnReasonsSettingsConfigurationSkeleton />
  }

  return (
    <Styles.Container>
      {hasChanges && <UnsavedChangesAlert hasPermission={canEdit} />}
      <SortingSettingsSection
        sortingValue={returnReasonsSorting}
        onChangeSorting={setReturnReasonsSorting}
        title={t('Ordenación motivos')}
        description={t(
          'Escoge el orden que se utilizará para mostrar los motivos de devolución en el Portal a los clientes'
        )}
        label={t('Ordenación motivos de devolución')}
      />
      <Divider />
      <SortingSettingsSection
        sortingValue={returnSubreasonsSorting}
        onChangeSorting={setReturnSubreasonsSorting}
        title={t('Ordenación submotivos')}
        description={t(
          'Escoge el orden que se utilizará para mostrar los submotivos dentro de cada motivo de devolución, en caso de que se hayan definido'
        )}
        label={t('Ordenación submotivos de devolución')}
      />
      <RejectedProductsSection
        notesAndImagesVisibilityValue={showRejectedNotesAndImages}
        onChangeNotesAndImageVisibility={setShowRejectedNotesAndImages}
      />
      <SaveChangesButtons
        hasChanges={canEdit && hasChanges}
        onSave={onSave}
        onRevertChanges={revertChanges}
        loading={saving}
        disabled={saving}
      />
    </Styles.Container>
  )
}

export default ReturnReasonsSettingsConfiguration
